import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnDestroy {
  @Output()
  change: EventEmitter<any> = new EventEmitter<any>();

  _pageNumber: number;
  _size: number;
  _totalElements: number;


  @Input()
  set pageNumber(value: number) {
    this._pageNumber = value;
    this.getPager();
  }

  get pageNumber(): number {
    return this._pageNumber;
  }

  @Input()
  set size(value: number) {
    this._size = value;
    this.getPager();
  }

  get size(): number {
    return this._size;
  }

  @Input()
  set totalElements(value: number) {
    this._totalElements = value;
    this.getPager();
  }

  get totalElements(): number {
    return this._totalElements;
  }

  totalPages: number;
  pageList: number[];

  ngOnInit() {
    this._size = this._size || 10;
    this.getPager();
  }

  setPage(page: number) {
    this._pageNumber = page;
    this.getPager();
    this.change.emit(page);
  }

  getPager() {
    // calculate total pages
    this.totalPages = Math.ceil(this._totalElements / this._size);
    // ensure current page isn't out of range
    if (this._pageNumber < 1) {
      this._pageNumber = 0;
    } else if (this._pageNumber > this.totalPages) {
      this._pageNumber = this.totalPages;
    }
    let startPage: number, endPage: number;
    if (this.totalPages < 10) {
      // less than 10 total pages so show all
      startPage = 0;
      endPage = this.totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (this._pageNumber < 6) {
        startPage = 0;
        endPage = 9;
      } else if (this._pageNumber + 4 >= this.totalPages) {
        startPage = this.totalPages - 9;
        endPage = this.totalPages;
      } else {
        startPage = this._pageNumber - 5;
        endPage = this._pageNumber + 4;
      }
    }

    // create an array of pages to ng-repeat in the pager control
    const pageList = Array.from(Array((endPage) - startPage).keys()).map(i => startPage + i);
    if (pageList.length > 0) {
      this.pageList = null;
      this.pageList = pageList;
    }
  }

  ngOnDestroy() {
    this.size = 10;
    this.totalPages = Math.ceil(this._totalElements / this._size);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/pagination/pagination.component.ts